// Needs refactoring
import 'ui-core/components/coolbar/js/coolbar';

(function () {
    let coolbar = {
        sections: null,
        holder: $('.coolBar--sections .coolBar__drop'),
        vPort: 'screen-sm',
        isMobile: false,
        coolbarElement: null,
        headerHeight: 0,
        isStickyBar: false,
        lock: true, // define lock and set default value, this lock will be used to make sure to run certain functionality and to run on every scroll event
        eventPage: document.querySelector('.event__content'),

        init: function () {
            coolbar.vPort = 'screen-md';

            coolbar.coolbarElement = $('.coolBar');
            coolbar.isStickyBar = coolbar.coolbarElement.hasClass('stickybar');
            coolbar.get.sections();
            coolbar.fill.sections();
            if (!coolbar.eventPage) {
                coolbar.control();
            }
            coolbar.addtionalControls();
        },
        control: function () {
            if ($('.journal-home').length) {
                coolbar.vPort = 'screen-md';
            }

            $(document).on(coolbar.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                $('.coolBar').addClass('coolBar--res'); // class will be used in our scss (to replace media queries)

                coolbar.isMobile = true;

                if ($('.stickybar.coolBar--res,.coolBar.coolBar--res').length > 0) {
                    $('.content>article.container').addClass('article--res');
                }
            });

            $(document).on(coolbar.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                $('.coolBar').removeClass('coolBar--res');
                $('.content article.container').removeClass('article--res');
                $(document).trigger('eventSetContentPadding');
                coolbar.isMobile = false;
                if (typeof UX.controller !== 'undefined') {
                    UX.controller.check();
                }
            });
        },
        addtionalControls: function () {
            let eventSection = document.querySelector('.coolBar__section #sections_Pop ul');
            if (eventSection) {
                eventSection.classList.remove('w-slide--list');
            }
        },
        get: {
            sections: function () {
                coolbar.sections = $(
                    '.article__content .article-section:not([style="display: none;"]) .section__title'
                );
            },
        },
        fill: {
            sections: function () {
                if ($('.coolBar--sections').length && UX.coolbar.sections.length > 1) {
                    $('.coolBar--sections').removeClass('hidden');
                    const ul = $('<ul class="rlist w-slide--list"/>').appendTo(UX.coolbar.holder);
                    UX.coolbar.sections.each(function () {
                        const $this = $(this).clone();
                        const li = $('<li/>').appendTo(ul);
                        const sectionId = $this.attr('id');
                        let link = $('<a class="w-slide__hide"/>')
                            .attr('href', '#' + sectionId)
                            .appendTo(li)
                            .on('mousedown', function (e) {
                                e.preventDefault();
                            });
                        $this.find('.section-footNote').remove();
                        $this[0].querySelector('math')
                            ? $('<span/>').html($this.html()).appendTo(link)
                            : $('<span/>').text($this.text()).appendTo(link);
                    });
                } else {
                    $('.coolBar--sections').remove();
                }

                if ($('.authorArticleInfoCon').length) {
                    $('.coolBar--sections .coolBar__drop').append(
                        '<li role="menuitem"><a class="w-slide__hide" href="#_ac_authorArticleInfoCon" target="_self"><span>Author and Article Information</span></a></li>'
                    );
                }
            },
        },
    };
    UX.coolbar = coolbar; // add to global namespace
})();
